/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AirlineResponse,
    AirlineResponseFromJSON,
    AirlineResponseFromJSONTyped,
    AirlineResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AirlineResponseCriteriaResponse
 */
export interface AirlineResponseCriteriaResponse {
    /**
     * 
     * @type {AirlineResponse}
     * @memberof AirlineResponseCriteriaResponse
     */
    value?: AirlineResponse;
    /**
     * 
     * @type {boolean}
     * @memberof AirlineResponseCriteriaResponse
     */
    exclude?: boolean;
}

export function AirlineResponseCriteriaResponseFromJSON(json: any): AirlineResponseCriteriaResponse {
    return AirlineResponseCriteriaResponseFromJSONTyped(json, false);
}

export function AirlineResponseCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AirlineResponseCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : AirlineResponseFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function AirlineResponseCriteriaResponseToJSON(value?: AirlineResponseCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': AirlineResponseToJSON(value.value),
        'exclude': value.exclude,
    };
}


